import React, { ComponentProps } from "react";
import ReviewsOverallRating from "../ReviewsOverallRating";
import { CustomerReviews, FilteredBy } from "../../reviewModels";
import FrequentlyMentioned from "../FrequentlyMentioned";
import AiReviewSummary from "../AiReviewSummary";
import ReviewsStarBreakdown from "../ReviewsStarBreakdown";
import ChildOrNull from "../../../ChildOrNull";
import { ProductDetailGroupingSelect } from "~/ProductDetails/ProductDetailPageResult";

type ReviewsOverviewProps = ComponentProps<"div"> & {
  reviews: CustomerReviews;
  itemNumber: string;
  productDetailGroupingSelect?: ProductDetailGroupingSelect[];
  isVirtualGroupMaster?: boolean;
  isProductReviewPage?: boolean;
  filteredBy?: FilteredBy;
  onRatingClick: (rating: number) => void;
};

const ReviewsOverviewV2 = ({
  reviews,
  itemNumber,
  productDetailGroupingSelect = [],
  isVirtualGroupMaster = false,
  isProductReviewPage,
  filteredBy,
  onRatingClick,
  className = "",
}: ReviewsOverviewProps) => {
  const { reviewWords, summary } = reviews;
  const hasReviewWords = (reviewWords?.length ?? 0) > 0;

  const getAiVgSummaryText = () => {
    const findSummaryInVgMember = productDetailGroupingSelect.find(
      (item) => item.itemNumber === itemNumber,
    );

    return findSummaryInVgMember?.customerReviewSummary ?? "";
  };

  const aiSummaryText =
    productDetailGroupingSelect.length > 0 && !isVirtualGroupMaster
      ? getAiVgSummaryText()
      : summary;

  const ratingAndBreakdown = (
    <>
      <ReviewsOverallRating
        reviews={reviews}
        aiSummaryText={aiSummaryText}
        isProductReviewPage={isProductReviewPage}
      />
      <ReviewsStarBreakdown
        reviews={reviews}
        isProductReviewPage={isProductReviewPage}
        filteredBy={filteredBy}
        onRatingClick={onRatingClick}
      />
    </>
  );
  let baseContainerClass = "box xxxsl:p-8";

  if (!isProductReviewPage) {
    baseContainerClass = `xxxsl:flex ${baseContainerClass}`;
  }

  const containerClass = isProductReviewPage
    ? "rounded-none border border-solid border-gray-200 border-b-0 border-l-0 border-r-0 border-t xl:flex"
    : baseContainerClass;

  return (
    <div className={`more-reviews products ${className}`}>
      <div className={`clearfix bg-white p-0 ${containerClass}`}>
        {isProductReviewPage ? (
          <div className="xl:w-1/2 md:flex xl:border-r xl:border-t-0 xl:border-b-0 xl:border-l-0 xl:border-solid border-gray-200">
            {ratingAndBreakdown}
          </div>
        ) : (
          ratingAndBreakdown
        )}

        <ChildOrNull condition={!!aiSummaryText}>
          <AiReviewSummary
            reviewWords={reviews.reviewWords}
            hasReviewWords={hasReviewWords}
            summaryText={aiSummaryText}
            isProductReviewPage={isProductReviewPage}
          />
        </ChildOrNull>
        <ChildOrNull condition={!aiSummaryText && hasReviewWords}>
          <FrequentlyMentioned
            reviewWords={reviews.reviewWords}
            isProductReviewPage={isProductReviewPage}
          />
        </ChildOrNull>
      </div>
    </div>
  );
};

export default ReviewsOverviewV2;
